export const CUSTOMER_BOOKING_DATE_FORMATS = {
  parse: {
    dateInput: "dd MMM yyyy",
    timeInput: "h:mm a",
  },
  display: {
    dateInput: "dd MMM yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "dd MMM yyyy",
    monthYearA11yLabel: "MMMM yyyy",
    timeInput: "h:mm a",
    timeOptionLabel: "h:mm a",
  },
};
